import { supabase } from '@/integrations/supabase/client';
import { track } from '@/lib/analytics';
import type { ShareTarget } from '../ShareTarget';

interface SendToEditorialInput {
  target: ShareTarget;
  caption: string;
  shareUrl: string;
  surface: 'sheet' | 'lite';
}

export async function sendToEditorialDraft({ target, caption, shareUrl, surface }: SendToEditorialInput): Promise<{ ok: boolean; code?: string }> {
  if (target.type !== 'activity') {
    track('editorial_handoff_requested', {
      source_type: 'event',
      target_type: target.type,
      surface,
      result: 'error',
    }, 'share');
    return { ok: false, code: 'unsupported_target' };
  }

  const body = caption ? `${caption}\n\n${shareUrl}` : target.title;
  const imageUrl = target.heroImageUrl || '';

  const { data, error } = await (supabase as any).rpc('create_social_post_draft', {
    p_source_type: 'event',
    p_source_id: target.id,
    p_title: target.title,
    p_body: body,
    p_image_url: imageUrl,
  });

  if (error || !data?.ok) {
    track('editorial_handoff_requested', {
      source_type: 'event',
      target_type: target.type,
      surface,
      result: 'error',
    }, 'share');
    return { ok: false, code: error?.message ?? data?.code ?? 'create_social_post_draft_failed' };
  }

  track('editorial_handoff_requested', {
    source_type: 'event',
    target_type: target.type,
    surface,
    result: 'success',
  }, 'share');

  return { ok: true };
}
